/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Pribyl (pribyl@cadwork.cz)
 *
 */

import {vec3} from "gl-matrix";

export class Ray {
    private _origin: vec3;
    private _direction:vec3;

    constructor(aOrigin: vec3, aDirection: vec3)
    {
        this._origin = vec3.clone(aOrigin);
        this._direction = vec3.clone(aDirection);
        vec3.normalize(this._direction, this._direction);
    }


    public getOrigin(): vec3 {
        return this._origin;
    }

    public getDirection(): vec3 {
        return this._direction;
    }

    public getPoint(t: number): vec3 {
        let out = vec3.create();
        vec3.scaleAndAdd(out, this._origin, this._direction, t);

        return out;
    }

    public setOrigin(aOrigin: vec3): void {
        this._origin = vec3.clone(aOrigin);
    }

    public setDirection(aDirection: vec3): void {
        this._direction = vec3.clone(aDirection);
    }
}

